import { Observable } from 'rxjs';
import { StorageParameters } from '../storage.service';
import { ApiBase } from './api.base';
import { Resource } from '@admin-shared/models/resource';
import { map } from 'rxjs/operators';
import { ResourceMapper } from '@admin-shared/mappers/resource.mapper';
import { ResourceCategory } from '@admin-shared/models/resource-category';

export class ResourcesApi extends ApiBase {
  model = '/resources';

  public createResource(data: Resource): Observable<Resource> {
    return this.http.post<Resource>(this.buildUrl(), data, {
      headers: this.setHeaders({
        Authorization: this.getStorage().getItem(
          StorageParameters.AccessTokenId
        ),
      }),
    });
  }

  public createResourceCategory(data: ResourceCategory): Observable<ResourceCategory> {
    return this.http.post<ResourceCategory>(this.buildUrl('category'), data, {
      headers: this.setHeaders({
        Authorization: this.getStorage().getItem(
          StorageParameters.AccessTokenId
        ),
      }),
    });
  }

  public updateResource(data: Resource): Observable<Resource> {
    return this.http.patch<Resource>(this.buildUrl(String(data.id)), data, {
      headers: this.setHeaders({
        Authorization: this.getStorage().getItem(
          StorageParameters.AccessTokenId
        ),
      }),
    });
  }

  public updateResourceCategory(data: ResourceCategory): Observable<ResourceCategory> {
    return this.http.patch<ResourceCategory>(this.buildUrl('category',String(data.id)), data, {
      headers: this.setHeaders({
        Authorization: this.getStorage().getItem(
          StorageParameters.AccessTokenId
        ),
      }),
    });
  }

  public getResources(categoryId: string, visible: boolean): Observable<Resource[]> {
    return this.http
      .get<Resource[]>(this.buildUrl(categoryId), {
        headers: this.setHeaders({
          Authorization: this.getStorage().getItem(
            StorageParameters.AccessTokenId
          ),
        }),
        params: visible ? this.setParams({ visible: String(visible) }) : {},
      })
      .pipe(map(ResourceMapper.mapItems));
  }

  public getCategories(id: string): Observable<ResourceCategory[]> {
    return this.http
      .get<ResourceCategory[]>(this.buildUrl('category', id), {
        headers: this.setHeaders({
          Authorization: this.getStorage().getItem(
            StorageParameters.AccessTokenId
          ),
        })
      });
  }

  public delete(id: string) {
    return this.http.delete(this.buildUrl(id), {
      headers: this.setHeaders({
        Authorization: this.getStorage().getItem(
          StorageParameters.AccessTokenId
        ),
      }),
    });
  }

  public deleteCategory(id: string) {
    return this.http.delete(this.buildUrl('category', id), {
      headers: this.setHeaders({
        Authorization: this.getStorage().getItem(
          StorageParameters.AccessTokenId
        ),
      }),
    });
  }
}
